import { render, staticRenderFns } from "./homeTrim.vue?vue&type=template&id=0ea7dced&scoped=true"
import script from "./homeTrim.vue?vue&type=script&lang=js"
export * from "./homeTrim.vue?vue&type=script&lang=js"
import style0 from "./homeTrim.vue?vue&type=style&index=0&id=0ea7dced&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7dced",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea7dced')) {
      api.createRecord('0ea7dced', component.options)
    } else {
      api.reload('0ea7dced', component.options)
    }
    module.hot.accept("./homeTrim.vue?vue&type=template&id=0ea7dced&scoped=true", function () {
      api.rerender('0ea7dced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/homeTrim.vue"
export default component.exports